var _style, _filter, _filter2, _filter3, _filter4, _filter5, _filter6, _filter7, _g, _path, _path2, _path3, _path4, _path5, _path6, _circle, _g2, _path7, _path8, _path9, _path10, _path11, _path12, _circle2, _g3, _path13, _path14, _path15, _path16, _path17, _path18, _circle3, _g4, _path19, _path20, _path21, _path22, _path23, _path24, _circle4, _g5, _g6, _path25, _path26, _path27, _path28, _path29, _path30, _circle5, _g7, _g8, _path31, _path32, _path33, _path34, _path35, _path36, _circle6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRecruitGenericFlow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 556.8 260.9",
    style: {
      enableBackground: "new 0 0 556.8 260.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{filter:url(#b);}\n\t.st1{fill:#F6F6F6;}\n\t.st2{fill:#D3D5D6;}\n\t.st3{fill:#1C75BC;}\n\t.st4{filter:url(#d);}\n\t.st5{filter:url(#f);}\n\t.st6{fill:#00A14B;}\n\t.st7{filter:url(#h);}\n\t.st8{fill:#662D91;}\n\t.st9{fill:none;stroke:#2E9EF2;stroke-width:8;stroke-miterlimit:10;}\n\t.st10{fill:#2E9EF2;stroke:#2E9EF2;stroke-miterlimit:10;}\n\t.st11{filter:url(#j);}\n\t.st12{filter:url(#l);}\n\t.st13{fill:#FFF200;}\n\t.st14{fill:none;stroke:#231F20;stroke-width:0.5;stroke-miterlimit:10;}\n\t.st15{filter:url(#n);}\n")), _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    filterUnits: "userSpaceOnUse",
    id: "n"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "o",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "o",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic",
    operator: "over"
  }))), _filter2 || (_filter2 = /*#__PURE__*/React.createElement("filter", {
    filterUnits: "userSpaceOnUse",
    id: "l"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "m",
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "m",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic",
    operator: "over"
  }))), _filter3 || (_filter3 = /*#__PURE__*/React.createElement("filter", {
    filterUnits: "userSpaceOnUse",
    id: "j"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "k",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "k",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic",
    operator: "over"
  }))), _filter4 || (_filter4 = /*#__PURE__*/React.createElement("filter", {
    filterUnits: "userSpaceOnUse",
    id: "h"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "i",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "i",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic",
    operator: "over"
  }))), _filter5 || (_filter5 = /*#__PURE__*/React.createElement("filter", {
    filterUnits: "userSpaceOnUse",
    id: "f"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "g",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "g",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic",
    operator: "over"
  }))), _filter6 || (_filter6 = /*#__PURE__*/React.createElement("filter", {
    filterUnits: "userSpaceOnUse",
    id: "d"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "e",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "e",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic",
    operator: "over"
  }))), _filter7 || (_filter7 = /*#__PURE__*/React.createElement("filter", {
    filterUnits: "userSpaceOnUse",
    id: "b"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "c",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "c",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic",
    operator: "over"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M19,6.2h144.9c7.1,0,12.9,5.8,12.9,12.9v50c0,7.1-5.8,12.9-12.9,12.9H19c-7.1,0-12.9-5.8-12.9-12.9v-50 C6.1,12,11.9,6.2,19,6.2z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M64,17.9h94.8c1.2,0,2.2,1,2.2,2.2v5.2c0,1.2-1,2.2-2.2,2.2H64c-1.2,0-2.2-1-2.2-2.2v-5.2 C61.7,18.9,62.7,17.9,64,17.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M91.9,32.1h64.2c0.2,0,0.4,0.2,0.4,0.5v1c0,0.2-0.2,0.5-0.4,0.5H91.9c-0.2,0-0.4-0.2-0.4-0.5v-1 C91.5,32.3,91.7,32.1,91.9,32.1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M91.9,37.4h64.2c0.2,0,0.4,0.2,0.4,0.5v1c0,0.2-0.2,0.5-0.4,0.5H91.9c-0.2,0-0.4-0.2-0.4-0.5v-1 C91.5,37.6,91.7,37.4,91.9,37.4z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M91.9,42.7h64.2c0.2,0,0.4,0.2,0.4,0.5v1c0,0.2-0.2,0.5-0.4,0.5H91.9c-0.2,0-0.4-0.2-0.4-0.5v-1 C91.5,42.9,91.7,42.7,91.9,42.7z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M70.5,32.8h12.1c0.2,0,0.4,0.2,0.4,0.5v12.1c0,0.2-0.2,0.5-0.4,0.5H70.5c-0.2,0-0.4-0.2-0.4-0.5V33.3 C70,33,70.2,32.8,70.5,32.8z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M22.7,16.2H45c3.3,0,5.9,2.6,5.9,5.9v44c0,3.3-2.6,5.9-5.9,5.9H22.7c-3.3,0-5.9-2.6-5.9-5.9v-44 C16.8,18.8,19.4,16.2,22.7,16.2z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 156.8,
    cy: 65.9,
    r: 7.1
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M19,92.6h144.9c7.1,0,12.9,5.8,12.9,12.9v50c0,7.1-5.8,12.9-12.9,12.9H19c-7.1,0-12.9-5.8-12.9-12.9v-50 C6.1,98.3,11.9,92.6,19,92.6z"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M64,104.3h94.8c1.2,0,2.2,1,2.2,2.2v5.2c0,1.2-1,2.2-2.2,2.2H64c-1.2,0-2.2-1-2.2-2.2v-5.2 C61.7,105.3,62.7,104.3,64,104.3z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M91.9,118.5h64.2c0.2,0,0.4,0.2,0.4,0.4v1c0,0.2-0.2,0.4-0.4,0.4H91.9c-0.2,0-0.4-0.2-0.4-0.4v-1 C91.5,118.7,91.7,118.5,91.9,118.5z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M91.9,123.8h64.2c0.2,0,0.4,0.2,0.4,0.4v1c0,0.2-0.2,0.4-0.4,0.4H91.9c-0.2,0-0.4-0.2-0.4-0.4v-1 C91.5,124,91.7,123.8,91.9,123.8z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M91.9,129.1h64.2c0.2,0,0.4,0.2,0.4,0.4v1c0,0.2-0.2,0.4-0.4,0.4H91.9c-0.2,0-0.4-0.2-0.4-0.4v-1 C91.5,129.3,91.7,129.1,91.9,129.1z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M70.5,119.2h12.1c0.2,0,0.4,0.2,0.4,0.4v12.1c0,0.2-0.2,0.4-0.4,0.4H70.5c-0.2,0-0.4-0.2-0.4-0.4v-12.1 C70,119.4,70.2,119.2,70.5,119.2z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M22.7,102.6H45c3.3,0,5.9,2.6,5.9,5.9v44c0,3.3-2.6,5.9-5.9,5.9H22.7c-3.3,0-5.9-2.6-5.9-5.9v-44 C16.8,105.2,19.4,102.6,22.7,102.6z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 156.8,
    cy: 152.3,
    r: 7.1
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "st5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M210,6.7h144.9c7.1,0,12.9,5.8,12.9,12.9v50c0,7.1-5.8,12.9-12.9,12.9H210c-7.1,0-12.9-5.8-12.9-12.9v-50 C197.1,12.5,202.9,6.7,210,6.7z"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M254.9,18.5h94.8c1.2,0,2.2,1,2.2,2.2v5.2c0,1.2-1,2.2-2.2,2.2h-94.8c-1.2,0-2.2-1-2.2-2.2v-5.2 C252.7,19.5,253.7,18.5,254.9,18.5z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M282.9,32.7h64.2c0.2,0,0.5,0.2,0.5,0.5v1c0,0.2-0.2,0.5-0.5,0.5h-64.2c-0.2,0-0.5-0.2-0.5-0.5v-1 C282.4,32.9,282.6,32.7,282.9,32.7z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M282.9,38h64.2c0.2,0,0.5,0.2,0.5,0.5v1c0,0.2-0.2,0.5-0.5,0.5h-64.2c-0.2,0-0.5-0.2-0.5-0.5v-1 C282.4,38.2,282.6,38,282.9,38z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M282.9,43.2h64.2c0.2,0,0.5,0.2,0.5,0.5v1c0,0.2-0.2,0.5-0.5,0.5h-64.2c-0.2,0-0.5-0.2-0.5-0.5v-1 C282.4,43.4,282.6,43.2,282.9,43.2z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M261.5,33.3h12.1c0.2,0,0.5,0.2,0.5,0.5v12.1c0,0.2-0.2,0.5-0.5,0.5h-12.1c-0.2,0-0.5-0.2-0.5-0.5V33.8 C261,33.5,261.2,33.3,261.5,33.3z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M213.7,16.7H236c3.3,0,5.9,2.6,5.9,5.9v44c0,3.3-2.6,5.9-5.9,5.9h-22.4c-3.3,0-5.9-2.6-5.9-5.9v-44 C207.8,19.4,210.4,16.7,213.7,16.7z"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 347.8,
    cy: 66.5,
    r: 7.1
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "st7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M392.9,6.2h144.9c7.1,0,12.9,5.8,12.9,12.9v50c0,7.1-5.8,12.9-12.9,12.9H392.9c-7.1,0-12.9-5.8-12.9-12.9v-50 C380,12,385.8,6.2,392.9,6.2z"
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M437.8,17.9h94.8c1.2,0,2.2,1,2.2,2.2v5.2c0,1.2-1,2.2-2.2,2.2h-94.8c-1.2,0-2.2-1-2.2-2.2v-5.2 C435.6,18.9,436.6,17.9,437.8,17.9z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M465.8,32.1H530c0.2,0,0.5,0.2,0.5,0.5v1c0,0.2-0.2,0.5-0.5,0.5h-64.2c-0.2,0-0.5-0.2-0.5-0.5v-1 C465.3,32.3,465.5,32.1,465.8,32.1z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M465.8,37.4H530c0.2,0,0.5,0.2,0.5,0.5v1c0,0.2-0.2,0.5-0.5,0.5h-64.2c-0.2,0-0.5-0.2-0.5-0.5v-1 C465.3,37.6,465.5,37.4,465.8,37.4z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M465.8,42.7H530c0.2,0,0.5,0.2,0.5,0.5v1c0,0.2-0.2,0.5-0.5,0.5h-64.2c-0.2,0-0.5-0.2-0.5-0.5v-1 C465.3,42.9,465.5,42.7,465.8,42.7z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M444.3,32.8h12.1c0.2,0,0.5,0.2,0.5,0.5v12.1c0,0.2-0.2,0.5-0.5,0.5h-12.1c-0.2,0-0.5-0.2-0.5-0.5V33.3 C443.9,33,444.1,32.8,444.3,32.8z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M396.6,16.2h22.3c3.3,0,5.9,2.6,5.9,5.9v44c0,3.3-2.6,5.9-5.9,5.9h-22.3c-3.3,0-5.9-2.6-5.9-5.9v-44 C390.7,18.8,393.3,16.2,396.6,16.2z"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "st8",
    cx: 530.7,
    cy: 65.9,
    r: 7.1
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M175.8,223.8c0,0,103.2,6.9,123.7-68.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M302.3,140.8c1.2,7.4,3.9,16.9,7.5,23.1l-10.7-6.5l-12.4,1.9C292.3,154.9,298.4,147.2,302.3,140.8 L302.3,140.8z"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    className: "st11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M19,178.9h144.9c7.1,0,12.9,5.8,12.9,12.9v50c0,7.1-5.8,12.9-12.9,12.9H19c-7.1,0-12.9-5.8-12.9-12.9v-50 C6.1,184.7,11.9,178.9,19,178.9z"
  }))), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M64,190.7h94.8c1.2,0,2.2,1,2.2,2.2v5.2c0,1.2-1,2.2-2.2,2.2H64c-1.2,0-2.2-1-2.2-2.2v-5.2 C61.7,191.7,62.7,190.7,64,190.7z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M91.9,204.9h64.2c0.2,0,0.4,0.2,0.4,0.4v1c0,0.2-0.2,0.4-0.4,0.4H91.9c-0.2,0-0.4-0.2-0.4-0.4v-1 C91.5,205.1,91.7,204.9,91.9,204.9z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M91.9,210.1h64.2c0.2,0,0.4,0.2,0.4,0.4v1c0,0.2-0.2,0.4-0.4,0.4H91.9c-0.2,0-0.4-0.2-0.4-0.4v-1 C91.5,210.3,91.7,210.1,91.9,210.1z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M91.9,215.4h64.2c0.2,0,0.4,0.2,0.4,0.4v1c0,0.2-0.2,0.4-0.4,0.4H91.9c-0.2,0-0.4-0.2-0.4-0.4v-1 C91.5,215.6,91.7,215.4,91.9,215.4z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M70.5,205.5h12.1c0.2,0,0.4,0.2,0.4,0.4v12.1c0,0.2-0.2,0.4-0.4,0.4H70.5c-0.2,0-0.4-0.2-0.4-0.4V206 C70,205.7,70.2,205.5,70.5,205.5z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M22.7,188.9H45c3.3,0,5.9,2.6,5.9,5.9v43.9c0,3.3-2.6,5.9-5.9,5.9H22.7c-3.3,0-5.9-2.6-5.9-5.9v-43.9 C16.8,191.6,19.4,188.9,22.7,188.9z"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "st8",
    cx: 156.8,
    cy: 238.7,
    r: 7.1
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    className: "st12"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "211.5,11 213.8,15.6 218.8,16.3 215.1,19.9 216,24.9 211.5,22.5 207,24.9 207.9,19.9 204.3,16.3  209.3,15.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "211.5,11 213.8,15.6 218.8,16.3 215.1,19.9 216,24.9 211.5,22.5 207,24.9 207.9,19.9 204.3,16.3  209.3,15.6  "
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    className: "st15"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M392.9,94.3h144.9c7.1,0,12.9,5.8,12.9,12.9v50c0,7.1-5.8,12.9-12.9,12.9H392.9c-7.1,0-12.9-5.8-12.9-12.9v-50 C380,100.1,385.8,94.3,392.9,94.3z"
  }))), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M437.8,106.1h94.8c1.2,0,2.2,1,2.2,2.2v5.2c0,1.2-1,2.2-2.2,2.2h-94.8c-1.2,0-2.2-1-2.2-2.2v-5.2 C435.6,107,436.6,106.1,437.8,106.1z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M465.8,120.2H530c0.2,0,0.5,0.2,0.5,0.4v1c0,0.2-0.2,0.4-0.5,0.4h-64.2c-0.2,0-0.5-0.2-0.5-0.4v-1 C465.3,120.4,465.5,120.2,465.8,120.2z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M465.8,125.5H530c0.2,0,0.5,0.2,0.5,0.4v1c0,0.2-0.2,0.4-0.5,0.4h-64.2c-0.2,0-0.5-0.2-0.5-0.4v-1 C465.3,125.7,465.5,125.5,465.8,125.5z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M465.8,130.8H530c0.2,0,0.5,0.2,0.5,0.4v1c0,0.2-0.2,0.4-0.5,0.4h-64.2c-0.2,0-0.5-0.2-0.5-0.4v-1 C465.3,131,465.5,130.8,465.8,130.8z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M444.3,120.9h12.1c0.2,0,0.5,0.2,0.5,0.4v12.1c0,0.2-0.2,0.4-0.5,0.4h-12.1c-0.2,0-0.5-0.2-0.5-0.4v-12.1 C443.9,121.1,444.1,120.9,444.3,120.9z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M396.6,104.3h22.3c3.3,0,5.9,2.6,5.9,5.9v44c0,3.3-2.6,5.9-5.9,5.9h-22.3c-3.3,0-5.9-2.6-5.9-5.9v-44 C390.7,107,393.3,104.3,396.6,104.3z"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "st8",
    cx: 530.7,
    cy: 154.1,
    r: 7.1
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecruitGenericFlow);
export default __webpack_public_path__ + "static/media/recruit-generic-flow.97c9b13407f3f86188273e7dfe88bbea.svg";
export { ForwardRef as ReactComponent };